import React, {
    useEffect, useState, useRef, useMemo
} from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import {
    useOrientationStore,
    useAgeStore,
    useHeightStore,
    useRaceStore,
    useEstimatesStore
} from '../store/useUserSelectionsStore';

import { useCriteriaUIStore, 
        useEstimatesUIStore,
        usePlanUIStore
 } from '../store/useUIStore';

import { alpha, styled } from '@mui/material/styles';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

import FavoriteIcon from '@mui/icons-material/Favorite';
import CakeIcon from '@mui/icons-material/Cake';
import GroupsIcon from '@mui/icons-material/Groups';
import HeightIcon from '@mui/icons-material/Height';
import PublicIcon from '@mui/icons-material/Public';
import FilterVintageIcon from '@mui/icons-material/FilterVintage';
import PaidIcon from '@mui/icons-material/Paid';
import CancelIcon from "../support_files/CancelIcon";
import { IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';

import DataPull from "./DataPull"
import Intro from "./Intro"

import Gender from "./Gender"
import Age from "./Age"
import Height from "./Height"
import RaceSegmentControl from "./RaceSegmentControl.js"
import Race from "./Race"
import Ethnicity from "./Ethnicity"
import Ancestry from "./Ancestry"

import marriageSupportStarter from "../support_files/marriageSupportStarter.json"
import sexualitySupportStarter from "../support_files/sexualitySupportStarter.json"
import genderSupportStarter from "../support_files/genderSupportStarter.json"



// import LocalData from "../local_data/LocalData.json"


import Estimates from "./Estimates"
import estimatesSupport from "../support_files/estimatesSupport.json"
import DiagramEstimates from "./DiagramEstimates"

import Plan from "./Plan"
import Discovery from "./Discovery"


import Test from "./test"

import Avatar from '@mui/material/Avatar';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';

import Menu from "./Menu"
import NumberFlow from '@number-flow/react'

import Fade from '@mui/material/Fade';

import Collapse from '@mui/material/Collapse';



import ageLocalData from "../local_data/ageLocalData.json";
import genderLocalData from "../local_data/genderLocalData.json";
import raceLocalData from "../local_data/raceLocalData.json";
import sexualityLocalData from "../local_data/sexualityLocalData.json";
import marriageLocalData from "../local_data/marriageLocalData.json";
import heightCMLocalData from "../local_data/heightCMLocalData.json";
import heightInchesLocalData from "../local_data/heightInchesLocalData.json";
import ethnicityLocalData from "../local_data/ethnicityLocalData.json";
import ancestryLocalData from "../local_data/ancestryLocalData.json";
import genderSupport from "../support_files/genderSupport.json";
import sexualitySupport from "../support_files/sexualitySupport.json";
import raceSupport from "../support_files/raceSupport.json";
import ethnicitySupport from "../support_files/ethnicitySupport.json";
import ethnicityGroupSupport from "../support_files/ethnicityGroupSupport.json";
import ancestrySupport from "../support_files/ancestrySupport.json";
import ancestryGroupSupport from "../support_files/ancestryGroupSupport.json";
import marriageSupport from "../support_files/marriageSupport.json";
// import estimatesSupport from "../support_files/estimatesSupport.json";

// import {
// View,
// KeyboardAvoidingView,
// TextInput,
// StyleSheet,
// Text,
// Platform,
// TouchableWithoutFeedback,
// Keyboard,
// } from 'react-native';


export default function Calculator() {

    // User Selections and various states
    const [ageData, setAgeData] = useState(ageLocalData);
    const [genderIdentityData, setGenderIdentityData] = useState(genderLocalData);
    const [raceData, setRaceData] = useState(raceLocalData);
    const [ethnicityData, setEthnicityData] = useState(ethnicityLocalData);
    const [ancestryData, setAncestryData] = useState(ancestryLocalData);
    const [sexualityData, setSexualityData] = useState(sexualityLocalData);
    const [marriageData, setMarriageData] = useState(marriageLocalData);
    const [heightDataCM, setHeightDataCM] = useState(heightCMLocalData);
    const [heightDataInch, setHeightDataInch] = useState(heightInchesLocalData);

    // Menu
    const [menuOpen, setMenuOpen] = useState(false);
    const [menuClose, setMenuClose] = useState(false);

    const handleReset = () => {
        localStorage.clear(); // Clears all localStorage including Zustand

        // Set ONLY the values you want persisted through reload
        const tempUIState = {
            pageValue: 1,
            tabValue: "1",
            activePreview: false,
            ageHintAppear: true,
            activeTabBar: false

            // All other UI values will use store defaults
        };

        localStorage.setItem('ui-criteria-storage', JSON.stringify({
            state: tempUIState,
            version: 0, // Zustand persist version
        }));

        // Set ONLY the values you want persisted through reload
        const tempIdentityState = {
            gender: genderSupportStarter,
            sexuality: sexualitySupportStarter,
            marriage: marriageSupportStarter
            // All other UI values will use store defaults
        };

        localStorage.setItem('identity-storage', JSON.stringify({
            state: tempIdentityState,
            version: 0, // Zustand persist version
        }));


        //   useCriteriaUIStore.getState().reset();
        // localStorage.removeItem('ui-criteria-storage');
        // localStorage.removeItem('estimates-ui-storage');
        //     setPageValue(1);
        //     setTabValue('1');
        //     orientationStore.setGender(genderSupportStarter);
        //     orientationStore.setSexuality(sexualitySupportStarter);
        //     orientationStore.setMarriage(marriageSupportStarter);
        // window.location.hash = "criteria";
        window.history.replaceState(null, "", window.location.pathname);
        window.location.reload(); // Reloads with fresh state
    };


    // ===== STORES =====
    const ageStore = useAgeStore();
    const heightStore = useHeightStore();
    const raceStore = useRaceStore();
    const estimatesStore = useEstimatesStore();

    // ===== LOCAL (in-session) STATE =====

    // ---------- IDENTITY ----------
    const gender = useOrientationStore((state) => state.gender);
    const setGender = useOrientationStore((state) => state.setGender);
    const sexuality = useOrientationStore((state) => state.sexuality);
    const setSexuality = useOrientationStore((state) => state.setSexuality);
    const marriage = useOrientationStore((state) => state.marriage);
    const setMarriage = useOrientationStore((state) => state.setMarriage);

// ---------- AGE ----------
const ageRange = useAgeStore((state) => state.ageRange);
const setAgeRange = useAgeStore((state) => state.setAgeRange);

// ---------- HEIGHT ----------
const imperial = useHeightStore((state) => state.imperial);
const setImperial = useHeightStore((state) => state.setImperial);
const height = useHeightStore((state) => state.height);
const setHeight = useHeightStore((state) => state.setHeight);
const heightRange = useHeightStore((state) => state.heightRange);
const setHeightRange = useHeightStore((state) => state.setHeightRange);

// ---------- RACE / ETHNICITY / ANCESTRY ----------
const activeEthnicityTab = useRaceStore((state) => state.activeEthnicityTab);
const setActiveEthnicityTab = useRaceStore((state) => state.setActiveEthnicityTab);

const activeRaceTab = useRaceStore((state) => state.activeRaceTab);
const setActiveRaceTab = useRaceStore((state) => state.setActiveRaceTab);

const raceAll = useRaceStore((state) => state.raceAll);
const setRaceAll = useRaceStore((state) => state.setRaceAll);

const race = useRaceStore((state) => state.race);
const setRace = useRaceStore((state) => state.setRace);

const ethnicityAll = useRaceStore((state) => state.ethnicityAll);
const setEthnicityAll = useRaceStore((state) => state.setEthnicityAll);

const ethnicity = useRaceStore((state) => state.ethnicity);
const setEthnicity = useRaceStore((state) => state.setEthnicity);

const ethnicityGroup = useRaceStore((state) => state.ethnicityGroup);
const setEthnicityGroup = useRaceStore((state) => state.setEthnicityGroup);

const ancestryAll = useRaceStore((state) => state.ancestryAll);
const setAncestryAll = useRaceStore((state) => state.setAncestryAll);

const ancestry = useRaceStore((state) => state.ancestry);
const setAncestry = useRaceStore((state) => state.setAncestry);

const ancestryGroup = useRaceStore((state) => state.ancestryGroup);
const setAncestryGroup = useRaceStore((state) => state.setAncestryGroup);



    // ---------- ESTIMATES ----------
    const [estimates, setEstimates] = useState(estimatesStore.estimates ?? estimatesSupport);


    // ===== DEBOUNCED SYNC TO STORES (persist to localStorage) =====
    const estimatesSyncTimer = useRef(null);

    // Estimates sync
    useEffect(() => {
        if (estimatesSyncTimer.current) {
            clearTimeout(estimatesSyncTimer.current);
        }

        estimatesSyncTimer.current = setTimeout(() => {
            estimatesStore.setEstimates(estimates);
        }, 3000);

        return () => {
            if (estimatesSyncTimer.current) {
                clearTimeout(estimatesSyncTimer.current);
            }
        };
    }, [estimates]);

    // ---------- Plan  ----------



    // ---------- UI (stored in local storage) ----------
    // Criteria UI 
    // Uncomment before publishing
        // const [pageValue, setPageValue] = useState(3);
    const pageValue = useCriteriaUIStore(state => state.pageValue);
    const setPageValue = useCriteriaUIStore(state => state.setPageValue);

    const activePreview = useCriteriaUIStore(state => state.activePreview);
    const setActivePreview = useCriteriaUIStore(state => state.setActivePreview);
    const activePageBar = useCriteriaUIStore(state => state.activePageBar);
    const setActivePageBar = useCriteriaUIStore(state => state.setActivePageBar);
    const disableTabs = useCriteriaUIStore(state => state.disableTabs);
    const setDisableTabs = useCriteriaUIStore(state => state.setDisableTabs);
    const activeTabBar = useCriteriaUIStore(state => state.activeTabBar);
    const setActiveTabBar = useCriteriaUIStore(state => state.setActiveTabBar);
    const hideTabs = useCriteriaUIStore(state => state.hideTabs);
    const setHideTabs = useCriteriaUIStore(state => state.setHideTabs);
    const tabValue = useCriteriaUIStore(state => state.tabValue);
    const setTabValue = useCriteriaUIStore(state => state.setTabValue);
    const tabTouched = useCriteriaUIStore(state => state.tabTouched);
    const setTabTouched = useCriteriaUIStore(state => state.setTabTouched);
    const blurOverlay = useCriteriaUIStore(state => state.blurOverlay);
    const setBlurOverlay = useCriteriaUIStore(state => state.setBlurOverlay);
    const ageHint = useCriteriaUIStore(state => state.ageHint);
    const setAgeHint = useCriteriaUIStore(state => state.setAgeHint);
    const ageHintFinished = useCriteriaUIStore(state => state.ageHintFinished);
    const setAgeHintFinished = useCriteriaUIStore(state => state.setAgeHintFinished);
    const heightHint = useCriteriaUIStore(state => state.heightHint);
    const setHeightHint = useCriteriaUIStore(state => state.setHeightHint);
    const heightHintFinished = useCriteriaUIStore(state => state.heightHintFinished);
    const setHeightHintFinished = useCriteriaUIStore(state => state.setHeightHintFinished);
    const raceHint = useCriteriaUIStore(state => state.raceHint);
    const setRaceHint = useCriteriaUIStore(state => state.setRaceHint);
    const raceHintFinished = useCriteriaUIStore(state => state.raceHintFinished);
    const setRaceHintFinished = useCriteriaUIStore(state => state.setRaceHintFinished);
    const ageHintAppear = useCriteriaUIStore(state => state.ageHintAppear);
    const setAgeHintAppear = useCriteriaUIStore(state => state.setAgeHintAppear);
    const ageHintAppearFinished = useCriteriaUIStore(state => state.ageHintAppearFinished);
    const setAgeHintAppearFinished = useCriteriaUIStore(state => state.setAgeHintAppearFinished);
    const tabHint = useCriteriaUIStore(state => state.tabHint);
    const setTabHint = useCriteriaUIStore(state => state.setTabHint);
    const tabTwoHintFinished = useCriteriaUIStore(state => state.tabTwoHintFinished);
    const setTabTwoHintFinished = useCriteriaUIStore(state => state.setTabTwoHintFinished);

    // Estimates UI 
    const estimatesPageAppear = useEstimatesUIStore(state => state.estimatesPageAppear);
    const setEstimatesPageAppear = useEstimatesUIStore(state => state.setEstimatesPageAppear);
    const estimatesPageAppearFinished = useEstimatesUIStore(state => state.estimatesPageAppearFinished);
    const setEstimatesPageAppearFinished = useEstimatesUIStore(state => state.setEstimatesPageAppearFinished);
    const estimatesHintFinished = useEstimatesUIStore(state => state.estimatesHintFinished);
    const setEstimatesHintFinished = useEstimatesUIStore(state => state.setEstimatesHintFinished);
    const estimatesHintAppear = useEstimatesUIStore(state => state.estimatesHintAppear);
    const setEstimatesHintAppear = useEstimatesUIStore(state => state.setEstimatesHintAppear);
      const showAdditionalCriteria = useEstimatesUIStore(state => state.showAdditionalCriteria);
      const setShowAdditionalCriteria = useEstimatesUIStore(state => state.setShowAdditionalCriteria);
    const returnToFoundationalCriteria = useEstimatesUIStore(state => state.returnToFoundationalCriteria);
    const setReturnToFoundationalCriteria = useEstimatesUIStore(state => state.setReturnToFoundationalCriteria);
    const estimatesAppear = useEstimatesUIStore(state => state.estimatesAppear);
    const setEstimatesAppear = useEstimatesUIStore(state => state.setEstimatesAppear);
    const currentEstimatesDialogueStep = useEstimatesUIStore(state => state.currentEstimatesDialogueStep);
    const setCurrentEstimatesDialogueStep = useEstimatesUIStore(state => state.setCurrentEstimatesDialogueStep);
    const estimatesFinishedAppearHint = useEstimatesUIStore(state => state.estimatesFinishedAppearHint);
    const setEstimatesFinishedAppearHint = useEstimatesUIStore(state => state.setEstimatesFinishedAppearHint);
    const estimatesFinishedHintFinished = useEstimatesUIStore(state => state.estimatesFinishedHintFinished);
    const setEstimatesFinishedHintFinished = useEstimatesUIStore(state => state.setEstimatesFinishedHintFinished);
    const estimatesZeroAppearHint = useEstimatesUIStore(state => state.estimatesZeroAppearHint);
    const setEstimatesZeroAppearHint = useEstimatesUIStore(state => state.setEstimatesZeroAppearHint);
    const estimatesZeroHintFinished = useEstimatesUIStore(state => state.estimatesZeroHintFinished);
    const setEstimatesZeroHintFinished = useEstimatesUIStore(state => state.setEstimatesZeroHintFinished);

    // Plan UI 
    const activePlanDrawer = usePlanUIStore(state => state.activePlanDrawer);
    const setActivePlanDrawer = usePlanUIStore(state => state.setActivePlanDrawer);

    // States are used to both assign values to UI elements in child components and for calculating dating pool size in parent component.
    function handlePull(newData) {
        // console.log(newData)
        // setRaceData(newData[1])
        // setEthnicityData(newData[0])
        // setAncestryData(newData[1])
        // setGenderIdentityData(newData[4])
        // setSexualityData(newData[5])
        // setMarriageData(newData[6])
        // setHeightDataCM(newData[7])
        // setHeightDataInch(newData[8])
    };

    function handleEstimates(newEstimate) {
        const estimateTemp =
            estimates.map((e) => {

                let newValue
                if (typeof newEstimate.value.replace === "function") { newValue = Number(newEstimate.value.replace(/\D/, '')) }
                else { newValue = Number(newEstimate.value) }

                if (e.estimate_id === newEstimate.estimate_id) {
                    const valueChanged = e.value !== newEstimate.value;

                    if (valueChanged) {
                        newEstimate.touched = true;
                    }

                    if (newEstimate.value === "") return {
                        ...newEstimate
                        , value: ""
                    }
                    else if (newValue > 1 && newValue <= 100) {
                        return {
                            ...newEstimate //Spread operator unpacks all parts of the object
                            , value: newValue //Specifying a value for an object key will overwrite the key:value pair in the spread operator
                        };
                    }
                    else if (newValue <= 1) return {
                        ...newEstimate
                        , value: 1
                    }
                    else if (newValue > 100) return {
                        ...newEstimate
                        , value: 100
                    }
                } else {
                    return e; //Other estimate questions that don't match the estimate_id get returned to the object unmodified
                }
            })
        setEstimates(estimateTemp)
    };


    // 🚻
    function handleGender(newGender) {
        const genderTemp =
            gender.map((g) => {
                if (g.gender === newGender.gender) {
                    return { ...newGender, selected: !newGender.selected };
                } else {
                    return g;
                }
            })
        setGender(genderTemp)
    };
    // 💕
    function handleSexuality(newSexuality) {
        const sexualityTemp =
            sexuality.map((s) => {
                if (s.sexuality === newSexuality.sexuality) {
                    return { ...newSexuality, selected: !newSexuality.selected };
                } else {
                    return s;
                }
            })
        setSexuality(sexualityTemp)
    };
    // 🎂
    function handleAge(newAgeRange) {
        setAgeRange(newAgeRange)
        setAgeHintFinished(true)
        setAgeHint(false)
        if(!heightHintFinished){setHeightHint(true)}
    };
    // 📐
    function handleImperial(event) {
        setImperial(event.target.checked);
    };

    function handleHeight(newHeight) {
        setHeight(newHeight)
        if(!raceHintFinished){setRaceHint(true)}
    };

    function handleHeightRange(newHeightRange) {
        setHeightRange(newHeightRange)
    };

    const prevImperialRef = useRef(); 

    useEffect(() => {
        if (prevImperialRef.current !== undefined && prevImperialRef.current !== imperial) {
            // ✅ Only runs when imperial toggles true/false after first render
            setHeight(imperial ? [58, 75] : [140, 190]);
            setHeightRange(imperial ? [58, 75] : [140, 190]);
        }
        prevImperialRef.current = imperial;
    }, [imperial]);


    // 👥
    const raceTabSupport = [
        { value: 0, label: 'Race', color: '#def3ff' },
        { value: 1, label: 'Ethnicity', color: '#abe0ff' },
        { value: 2, label: 'Ancestry', color: '#59b7ff' }

    ]
    function handleRaceTab(raceTab) {
        setActiveRaceTab(raceTab);
        setActiveEthnicityTab(raceTab)
        // onChange && onChange(idx);
    };
    function handleRace(newRace) {
        const raceTemp =
            race.map((r) => {
                if (r.race === newRace.race) {
                    return newRace;
                } else {
                    return r;
                }
            })
        setRace(raceTemp)

        if (raceTemp.every((e) => e.selected === true)) { setRaceAll(true) }
        else { setRaceAll(false) }
    };
    // 🌎
    function handleEthnicity(newEthnicity) {
        // First update selected ethnicity checkbox.
        // Note 1
        const ethnicityTemp =
            ethnicity.map((e) => {
                if (e.ethnicity === newEthnicity.ethnicity) {
                    return newEthnicity;
                } else {
                    return e;
                }
            })
        setEthnicity(ethnicityTemp)

        if (ethnicityTemp.every((e) => e.selected === true)) { setEthnicityAll(true) }
        else { setEthnicityAll(false) }

        // Obtain only ethnicities in ethnicity group of interest.
        const ethnicityGroupTemp = []
        ethnicityTemp.map((e) => {
            if (e.ethnicity_group === newEthnicity.ethnicity_group) {
                return ethnicityGroupTemp.push(e);
            }
        })
        // Determine whether all, none, or some ethnicity check boxes of an ethnicity group are selected.
        const allChildrenSelected = () => {
            if (ethnicityGroupTemp.every((e) => e.selected === true)) { return true }
            else if (ethnicityGroupTemp.every((e) => e.selected === false)) { return false }
            else { return "indeterminate" }
        }
        // Update ethnicityGroup selected value based on if the ethnicity that was just selected made it so that all, none, or some of the ethnicity group's ethnicity boxes were selected.
        setEthnicityGroup(
            ethnicityGroup.map((g) => {
                if (g.ethnicity_group === newEthnicity.ethnicity_group) {
                    if (allChildrenSelected() === true || allChildrenSelected() === false) {
                        return {
                            ...g
                            , selected: allChildrenSelected()
                            , indeterminate: false
                        };
                    }
                    else {
                        return {
                            ...g
                            , indeterminate: true
                        }
                    }
                } else {
                    return g;
                }
            })
        )
    }
    function handleEthnicityGroup(newEthnicityGroup) {
        setEthnicityGroup(
            ethnicityGroup.map((g) => {
                if (g.ethnicity_group === newEthnicityGroup.ethnicity_group) {
                    return newEthnicityGroup;
                } else {
                    return g;
                }
            })
        )
        const ethnicityTemp =
            ethnicity.map((e) => {
                if (e.ethnicity_group === newEthnicityGroup.ethnicity_group) {
                    e.selected = newEthnicityGroup.selected ? true : false
                    return e;
                } else {
                    return e;
                }
            })
        setEthnicity(ethnicityTemp)

        if (ethnicityTemp.every((e) => e.selected === true)) { setEthnicityAll(true) }
        else { setEthnicityAll(false) }
    };

    // 🌻🌻🌻
    // Memoize organized data so it doesn't recalculate every render
    const organizedAncestry = useMemo(() => {
        const grouped = new Map();

        ancestry.forEach((ancestry) => {
            const groupKey = ancestry.ancestry_group;
            if (!grouped.has(groupKey)) {
                const group = ancestryGroup.find(g => g.ancestry_group === groupKey);
                grouped.set(groupKey, { ...group, children: [] });
            }
            grouped.get(groupKey).children.push(ancestry);
        });

        return Array.from(grouped.values());
    }, [ancestry, ancestryGroup]);

    function handleAncestry(newAncestry) {
        const ancestryTemp = ancestry.map((e) =>
            e.ancestry === newAncestry.ancestry ? newAncestry : e
        );

        setAncestry(ancestryTemp);

        // Check if all selected
        const allSelected = ancestryTemp.every((e) => e.selected);
        setAncestryAll(allSelected);

        // Get children in same group
        const ancestryGroupChildren = ancestryTemp.filter(
            (e) => e.ancestry_group === newAncestry.ancestry_group
        );

        // Determine parent state - calculate once
        const allChildrenSelected = ancestryGroupChildren.every((e) => e.selected);
        const noChildrenSelected = ancestryGroupChildren.every((e) => !e.selected);

        setAncestryGroup(
            ancestryGroup.map((g) => {
                if (g.ancestry_group !== newAncestry.ancestry_group) return g;

                if (allChildrenSelected) {
                    return { ...g, selected: true, indeterminate: false };
                } else if (noChildrenSelected) {
                    return { ...g, selected: false, indeterminate: false };
                } else {
                    return { ...g, indeterminate: true };
                }
            })
        );
    }

    function handleAncestryGroup(newAncestryGroup) {
        setAncestryGroup(
            ancestryGroup.map((g) =>
                g.ancestry_group === newAncestryGroup.ancestry_group ? newAncestryGroup : g
            )
        );

        const ancestryTemp = ancestry.map((e) =>
            e.ancestry_group === newAncestryGroup.ancestry_group
                ? { ...e, selected: newAncestryGroup.selected } // No mutation
                : e
        );

        setAncestry(ancestryTemp);
        setAncestryAll(ancestryTemp.every((e) => e.selected));
    }
    // 💍💍💍
    function handleMarriage(newMarriage) {
        const marriageTemp =
            marriage.map((m) => {
                if (m.marriage === newMarriage.marriage) {
                    return { ...newMarriage, selected: !newMarriage.selected };
                } else {
                    return m;
                }
            })
        setMarriage(marriageTemp)
    };




    // Helper Functions
    function resetter(formName, active) {
        if (formName === 'race') {
            setRaceAll(active)
            setRace(
                race.map((r) => {
                    return { ...r, selected: active }
                })
            )
        }
        else if (formName === 'ethnicity') {
            setEthnicityAll(active)
            setEthnicityGroup(
                ethnicityGroup.map((e) => {
                    return { ...e, selected: active, indeterminate: false }
                })
            )
            setEthnicity(
                ethnicity.map((e) => {
                    return { ...e, selected: active, indeterminate: false }
                })
            )
        }
        else if (formName === 'ancestry') {
            setAncestryAll(active)
            setAncestryGroup(
                ancestryGroup.map((e) => {
                    return { ...e, selected: active, indeterminate: false }
                })
            )
            setAncestry(
                ancestry.map((e) => {
                    return { ...e, selected: active, indeterminate: false }
                })
            )
        }

    }

  const pageHashMap = {
    1: "criteria",
    2: "estimates",
    3: "plan",
  };

const handlePageChange = (newValue, drawerName = null) => {
  setPageValue(newValue);
  setActivePlanDrawer(drawerName);

    // Only update URL if a drawer is open
  if (drawerName) {
    window.location.hash = drawerName; // e.g. #average-is-ugly
  } else {
    // Clear hash entirely for main pages
    window.history.replaceState(null, "", window.location.pathname);
  }
//   let newHash = "";
//   if (newValue === 1) newHash = "criteria";
//   else if (newValue === 2) newHash = "estimates";
//   else if (newValue === 3) {
//     newHash = "plan";
//     if (drawerName) newHash += `-${drawerName}`;
//   }

//   window.location.hash = newHash; // updates URL without reload
};

useEffect(() => {
  const syncHash = () => {
    const hash = window.location.hash.replace("#", "");

    if (hash) {
      // Drawer should open
      setPageValue(-1);
      setActivePlanDrawer(hash);
    }
    // If no hash, don't do anything - keep current state
  };

  syncHash(); // Run immediately on mount
  window.addEventListener("hashchange", syncHash);

  return () => {
    window.removeEventListener("hashchange", syncHash);
  };
}, []); // Empty dependency array is fine
// useEffect(() => {
//   const syncHash = () => {
//     const hash = window.location.hash.replace("#", "");
//     if (!hash) return setPageValue(0);

//     if (hash === "criteria") {
//       setPageValue(1);
//       setActivePlanDrawer(null);
//     } else if (hash === "estimates") {
//       setPageValue(2);
//       setActivePlanDrawer(null);
//     } else if (hash.startsWith("plan")) {
//       setPageValue(3);
//       const drawerName = hash.startsWith("plan-") ? hash.replace("plan-", "") : null;
//       setActivePlanDrawer(drawerName);
//     }
//   };

//   syncHash(); // sync on mount
//   window.addEventListener("hashchange", syncHash); // sync if user edits hash manually

//   return () => window.removeEventListener("hashchange", syncHash);
// }, []);


    // 🚦UI states & functions for hints

    // This state is used by the TabContext component that controls the menu tabs
    // Uncomment before publishing
    // const [disableTabs, setDisableTabs] = useState(false);




    // Uncomment before publishing
    // Start off with all orientation fields being selected in the beginning to let user preview total population count.
    useEffect(() => {
        if (pageValue === 1 && activePreview) {
            setTimeout(() => {
                // setGender(genderSupportStarterTEST)
                // setSexuality(sexualitySupportStarterTEST)
                // setMarriage(marriageSupportStarterTEST)
                setGender(genderSupportStarter)
                setSexuality(sexualitySupportStarter)
                setMarriage(marriageSupportStarter)
                setActivePreview(false)
                // setTimeout(() => {
                //     setHideTabs(true)
                // }, 1000);
            }, 2000);
            setTimeout(() => {
                setAgeHintAppear(true)
            }, 1500);
        }
    }
        , [pageValue])

    // Display criteria bar if all orientation sections are selected
    useEffect(() => {
        let tabTimeout
        let ageHintTimeout

        if (activePreview === false) {
            if ( //If at least one of the orientaiton values are selected
                ((!gender.every((g) => g.selected === false))
                    && (!sexuality.every((g) => g.selected === false))
                    && (!marriage.every((g) => g.selected === false)))
            ) {
                if (!activePreview) { setDisableTabs(false) }
                setActiveTabBar(true)

                // Commented out because returning to the age tab users would have to wait for the age tab to appear 
                // tabTimeout = setTimeout(() => {
                //     setHideTabs(false)
                //     if (!activePreview) { setDisableTabs(false) }

                // }, 3500)

                if (!ageHintAppearFinished && !ageHint) {
                    ageHintTimeout = setTimeout(() => {
                        setAgeHint(true)
                        setBlurOverlay(true)
                    }, 500)

                }
            }
            else {
                setActiveTabBar(false)
                setTabValue("1")
            }
        }
        return () => {
            clearTimeout(tabTimeout)
            clearTimeout(ageHintTimeout)
        };
    }

        , [gender, sexuality, marriage,])

    // Criteria tab hints



    // Tab hint close function
    const hintCloseFunction = (setState1, setState2) => {
        setState1(false)
        setTimeout(() => { setState2(true) }, 1000)
    }
    // Race tabs Hint
    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
        setTabTouched([...tabTouched, Number(newValue)]);
        if (tabValue === '3') {
            setHeightHintFinished(true);
        }
        if (tabValue === '4') {
            setRaceHintFinished(true);
        }
        // This logic was necessary because for some reason the MUI Collapse component would expand before the Race tab was active. That, or the first render would result in instantly displaying it, instead of expanding it.
        // setTimeout(() => {
        //     if (newValue === "4" && firstRaceAlertTrigger) {
        //         setFirstRaceAlert(true) // show the first race alert.
        //         setFirstRaceAlertTrigger(false)
        //     } // never show the first race alert afterwards
        // }, 200);
    }
    // Hint to indicate to move on to My Estimates page
    useEffect(() => {
        setBlurOverlay(false) //Changing to a new tab or page should remove the overlay blur

        let summedTabs = [...new Set(tabTouched)].reduce((partialSum, a) => partialSum + a, 0) // Get unique values of tabs touched and sum them and check to see it equals: 1:6 = 16
        let timeoutId;
        if (pageValue === 2) {
            setTabHint(false)
        }
        else if (summedTabs >= 9 && tabTwoHintFinished === false) {
            setActivePageBar(true)
            timeoutId = setTimeout(() => { setTabHint(2); setBlurOverlay(true) }, 4000)
            setTabTwoHintFinished(true)
            setEstimatesPageAppear(true)
        }
        if (pageValue === 3) {
            setTabHint(false);
            setEstimatesFinishedHintFinished(true); //Might need to change to setEstimatesFinishedAppearHint if a cat appears in the next page
            setEstimatesFinishedAppearHint(false)
        }

        return () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        };
    }
        , [tabTouched, pageValue]);




    const zeroCheckTimer = useRef(null);

    // Estimates Into dialogue
    const currentEstimatesDialogueSteps = [
        {
            header: "Your Estimates",
            content: (
                <>
                    <p>The diagram above shows your <span className="highlight">Foundational Criteria</span> and the size of your dating pool.</p>
                </>
            )
        },
        {
            header: "Your Estimates",
            content: (
                <>
                    <p>Not everyone in this starting pool is a match, so we consider various <span className="highlight">Additional Criteria</span>, like looks, job, dating intentions, etc.</p>
                </>
            )
        },
        {
            header: "Your Estimates",
            content: (
                <>
                    <p>Your dating pool starts off broad with your <span className="highlight">Foundational Criteria</span>, then narrows with <span className="highlight">Additional Criteria</span>, and now you’ll <span className="highlight">estimate</span> that narrowing.</p>
                </>
            )
        }
    ];


    // Function to go to next dialogue step
    const nextDialogueStep = () => {
        if (currentEstimatesDialogueStep < currentEstimatesDialogueSteps.length - 1) {
            setCurrentEstimatesDialogueStep(currentEstimatesDialogueStep + 1)
        }
        else {
            // If it's the last step, close the dialogue
            hintCloseFunction(setEstimatesHintAppear, setEstimatesHintFinished)
            setEstimatesAppear(true)
                ;
        }
    };
    useEffect(() => {
        if (currentEstimatesDialogueStep === 1) { setShowAdditionalCriteria(true) }
        else if (currentEstimatesDialogueStep > 1) { setReturnToFoundationalCriteria(true) }
    }
        , [currentEstimatesDialogueStep, estimatesHintFinished]);


    useEffect(() => {
        if (!estimatesFinishedAppearHint && !estimatesFinishedHintFinished) {
            if (estimates.every((e) => e.touched !== false)) { // Switched to checking if all are not false because the second quqesiton is optional and so I removed that object property from it.
                setTimeout(() => {
                    setEstimatesFinishedAppearHint(true)
                    setTabHint(3)
                    setBlurOverlay(true)

                }, 2500)
            }
        }
    }
        , [estimates]);


    // End of hint section


    // 🤖🤖🤖 🤖🤖🤖 🤖🤖🤖 🤖🤖🤖 🤖🤖🤖 🤖🤖🤖 🤖🤖🤖 🤖🤖🤖 🤖🤖🤖 🤖🤖🤖 🤖🤖🤖 🤖🤖🤖
    // Dating pool calculation logic
    const [datingPoolCount, setDatingPoolCount] = useState(0)
    const [genderPercent, setGenderPercent] = useState(0)
    const [agePercent, setAgePercent] = useState(0)
    const [racePercent, setRacePercent] = useState(0)
    const [ethnicityPercent, setEthnicityPercent] = useState(100) // These need to be set to 100 because when switching from the default race tab to ethnicity or ancestry, it would switch the number from 0 to 100, which is a bit distracting (Though this would only happen if race was 100%, meaning they didn't touch anything, then switched to Ethnicity and they would see the kpi go from 100% to 0%, then back to 100%).
    const [ancestryPercent, setAncestryPercent] = useState(100)
    const [heightPercent, setHeightPercent] = useState(0)

    function handleCount(newDatingPoolCount) {
        setDatingPoolCount(newDatingPoolCount)
    };

    // const [activeRaceAlert, setActiveRaceAlert] = useState(false);
    // // const [firstRaceAlertTrigger, setFirstRaceAlertTrigger] = useState(true);
    // // const [firstRaceAlert, setFirstRaceAlert] = useState(false);
    // const [useRaceAlert, setUseRaceAlert] = useState(true);
    // const [activeEthnicityAlert, setActiveEthnicityAlert] = useState(false);
    // const [useEthnicityAlert, setUseEthnicityAlert] = useState(true);
    // const [activeAncestryAlert, setActiveAncestryAlert] = useState(false);
    // const [useAncestryAlert, setUseAncestryAlert] = useState(true);

    useEffect(() => {
        let totalAgePop = 0; // Population size for all genders and entire age range.

        let datingPoolCountMenTemp = 0 // Selected gender and age range.
        let datingPoolCountWomenTemp = 0 // Selected gender and age range.
        let datingPoolCountBothTemp = 0; // Population size for selected age range and both genders.
        let datingPoolCountTemp = 0;

        // Gender Identity percent
        let menPercent = 0;
        let transMenPercent = 0;
        let womenPercent = 0;
        let transWomenPercent = 0;
        let transgenderPercent = 0;
        let otherPercent = 0;

        let activeGenderStatus = 0;
        if (gender[0]["selected"] && gender[1]["selected"]) {
            activeGenderStatus = 0
        } // Both
        else if (gender[1]["selected"]) {
            activeGenderStatus = 1
        } // Male
        else if (gender[0]["selected"]) {
            activeGenderStatus = 2
        } // Female
        else {
            activeGenderStatus = 0
        }

        // Sexual Orientation percents for each gender identity
        let menSexualityPercent = 0;
        let transMenSexualityPercent = 0;
        let womenSexualityPercent = 0;
        let transWomenSexualityPercent = 0;
        let transgenderSexualityPercent = 0;
        let otherSexualityPercent = 0;

        // Marrital Status percents for each gender
        let menMarriagePercent = 0;
        let womenMarriagePercent = 0;

        // Gender Identity count * Sexual Orientation percents for each gender identity
        let finalMenPop = 0;
        let finalWomenPop = 0;
        let finalBothPop = 0;

        // Ethnicity related percents
        let racePercentTemp = 0;
        let ethnicityPercentTemp = 0;
        let ancestryPercentTemp = 0;

        // race mapping guide
        let APercent = null; // a: asian
        let BPercent = null; // b: black
        let LPercent = null; // l: latino
        let MPercent = null; // m: middle eastern
        let NPercent = null; // n: native
        let PPercent = null; // p: pacific islander
        let WPercent = null; // w: white
        let TPercent = null; // w: white, t: two or more
        let OPercent = null; // o: other


        // if ([ageData, genderIdentityData, sexualityData, raceData, ethnicityData, ancestryData, heightDataCM, heightDataInch].every((g) => g.selected !== null)) { // Wait for DataPull Component to finish first.


        // 🚻🚻🚻
        if (!gender.every((g) => g.selected === false)) {
            genderIdentityData.map(gData => {
                gender.map(g => {
                    if (g.selected === true && g.gender === gData.gender) {
                        if (g.gender === "Men") { menPercent += parseFloat(gData["pop_decimal"]) }
                        else if (g.gender === "Trans Men") { transMenPercent += parseFloat(gData["pop_decimal"]) }
                        else if (g.gender === "Women") { womenPercent += parseFloat(gData["pop_decimal"]) }
                        else if (g.gender === "Trans Women") { transWomenPercent += parseFloat(gData["pop_decimal"]) }
                        else if (g.gender === "Transgender") { transgenderPercent += parseFloat(gData["pop_decimal"]) }
                        else if (g.gender === "Other") { otherPercent += parseFloat(gData["pop_decimal"]) }
                    }
                })
            })
            // 💕💕💕
            sexualityData.map(sData => {
                sexuality.map(s => {
                    if (s.selected === true && s.sexuality === sData.sexuality) {
                        switch (true) {
                            case (sData["menPercent"] !== null): menSexualityPercent += parseFloat(sData["menPercent"])
                            case (sData["transMenPercent"] !== null): transMenSexualityPercent += parseFloat(sData["transMenPercent"])
                            case (sData["womenPercent"] !== null): womenSexualityPercent += parseFloat(sData["womenPercent"])
                            case (sData["transWomenPercent"] !== null): transWomenSexualityPercent += parseFloat(sData["transWomenPercent"])
                            case (sData["transgenderPercent"] !== null): transgenderSexualityPercent += parseFloat(sData["transgenderPercent"])
                            case (sData["otherPercent"] !== null): otherSexualityPercent += parseFloat(sData["otherPercent"])
                                break
                        }
                    }
                }
                )
            })
            // Ensure gender identity percents don't exceed 100%
            womenSexualityPercent = womenSexualityPercent > 1 ? 1 : womenSexualityPercent
            transWomenSexualityPercent = transWomenSexualityPercent > 1 ? 1 : transWomenSexualityPercent
            menSexualityPercent = menSexualityPercent > 1 ? 1 : menSexualityPercent
            transMenSexualityPercent = transMenSexualityPercent > 1 ? 1 : transMenSexualityPercent
            transgenderSexualityPercent = transgenderSexualityPercent > 1 ? 1 : transgenderSexualityPercent
            otherSexualityPercent = otherSexualityPercent > 1 ? 1 : otherSexualityPercent

            // 🎂🎂🎂
            ageData.map(ageCount => {
                totalAgePop += parseInt(Object.values(ageCount)[1].replace(",", ""))
                if (ageCount.age >= ageRange[0] && ageCount.age <= ageRange[1]) {
                    datingPoolCountMenTemp += parseInt(Object.values(ageCount)[3].replace(",", ""))
                    datingPoolCountWomenTemp += parseInt(Object.values(ageCount)[2].replace(",", ""))
                    datingPoolCountBothTemp += parseInt(Object.values(ageCount)[1].replace(",", ""))

                }
            })

            // 💍💍💍
            // These arrays hold every marital status selected and their respective age ranges and percents.
            let menMarriageTemp = [];
            let womenMarriageTemp = [];

            marriageData.map(mData => {
                marriage.map(m => {
                    if (m.selected === true && mData.marriage.includes(m.marriage)) {
                        if (mData.marriage.includes("Male")) {
                            menMarriageTemp.push(mData)
                        }
                        else { womenMarriageTemp.push(mData) }
                    }
                })
            })
            // Populate an array with every age value in the user defined age range.
            let ageNumberRange = [];
            for (var i = ageRange[0]; i <= ageRange[1]; i++) {
                ageNumberRange.push(i);
            }
            // * Need to update this function to also do the same for female*
            let maritalCalc = (genderMaritalArray, genderVar) => {

                let allMaritalPercents = [];
                // for each marital status in our single gender marital temp array
                genderMaritalArray.map(menMarriageCategory => {
                    let maritalPercents = [];

                    // for each age range for the marital status
                    let ageRangeTemp = []; // Array of one age range marital percent per age that fell into user defined age range
                    for (var [age, percent] of Object.entries(menMarriageCategory)) {
                        let min = Number(age.split('-')[0]);
                        let max = Number(age.split('-')[1]);
                        let rangeTemp = { "ageRange": age, "count": 0 }

                        // for each age in the user defined age range
                        ageNumberRange.map(a => {
                            if (a >= min && a <= max) { ageRangeTemp.push(parseFloat(percent)) }
                        })
                    }
                    // console.log(ageRangeTemp)
                    // Take an average for each marital status' age percents. 
                    maritalPercents = maritalPercents.concat(ageRangeTemp)
                    const sum = maritalPercents.reduce((a, c) => a + c, 0);
                    const avg = sum / maritalPercents.length;
                    allMaritalPercents = allMaritalPercents.concat(avg)
                })
                // Add up all of the averaged marital statuses
                const totalGenderSum = allMaritalPercents.reduce((a, c) => a + c, 0);
                // console.log(totalGenderSum)

                if (genderVar === "men") {
                    menMarriagePercent = totalGenderSum
                }
                else if (genderVar === "women") {
                    womenMarriagePercent = totalGenderSum
                }
            }
            maritalCalc(menMarriageTemp, "men")
            maritalCalc(womenMarriageTemp, "women")

            // Combine gender identity, sexuality, and marital status percents
            finalWomenPop = (
                ((womenPercent * womenSexualityPercent) + (transWomenPercent * transWomenSexualityPercent))
                * menMarriagePercent
            )
            finalMenPop = (
                ((menPercent * menSexualityPercent) + (transMenPercent * transMenSexualityPercent))
                * womenMarriagePercent
            )
            finalBothPop = (
                ((transgenderPercent * transgenderSexualityPercent) + (otherPercent * otherSexualityPercent))
                * ((menMarriagePercent + womenMarriagePercent) / 2)
            )

            let finalGenderPercent = (
                ((datingPoolCountMenTemp * finalMenPop)
                    + (datingPoolCountWomenTemp * finalWomenPop)
                    + ((datingPoolCountMenTemp + datingPoolCountWomenTemp) * finalBothPop))
                /
                (datingPoolCountMenTemp + datingPoolCountWomenTemp)
            )
            if (finalGenderPercent > 0 && finalGenderPercent < .01) { setGenderPercent((finalGenderPercent * 100)) }
            else { setGenderPercent((finalGenderPercent.toFixed(2) * 100).toFixed(0)) }


            // Use age data for each gender to multiply by gender identity, sexuality, and marital status percents to calculate final population count
            // 👥👥👥
            setAgePercent(((datingPoolCountBothTemp / totalAgePop) * 100).toFixed(0))

            // Add up the race/ethnicity/ancestry checkboxes that were selected 
            if (activeEthnicityTab === 0) { // Race tab active
                raceData.map(rData => {
                    race.map(r => {
                        if (r.selected === true && r.race === rData.race) {
                            racePercentTemp += parseFloat(rData["decimal"])
                            if (r.r === "A") { APercent += parseFloat(rData["decimal"]) }
                            else if (r.r === "B") { BPercent += parseFloat(rData["decimal"]) }
                            else if (r.r === "L") { LPercent += parseFloat(rData["decimal"]) }
                            else if (r.r === "M") { MPercent += parseFloat(rData["decimal"]) }
                            else if (r.r === "N") { NPercent += parseFloat(rData["decimal"]) }
                            else if (r.r === "P") { PPercent += parseFloat(rData["decimal"]) }
                            else if (r.r === "W") { WPercent += parseFloat(rData["decimal"]) }
                            else if (r.r === "T") { TPercent += parseFloat(rData["decimal"]) }
                            else if (r.r === "O") { OPercent += parseFloat(rData["decimal"]) }
                        }
                    })
                })
                if (racePercentTemp > 0 && racePercentTemp < .01) { setRacePercent((racePercentTemp * 100)) }
                else { setRacePercent((racePercentTemp * 100).toFixed(0)) }
            }
            // 🌎🌎🌎
            else if (activeEthnicityTab === 1) { // Ethnicity tab active
                ethnicityData.map(eData => {
                    ethnicity.map(e => {
                        if (e.selected === true && e.ethnicity === eData.ethnicity) {
                            ethnicityPercentTemp += parseFloat(eData["decimal"])
                            if (e.r === "A") { APercent += parseFloat(eData["decimal"]) }
                            else if (e.r === "B") { BPercent += parseFloat(eData["decimal"]) }
                            else if (e.r === "L") { LPercent += parseFloat(eData["decimal"]) }
                            else if (e.r === "M") { MPercent += parseFloat(eData["decimal"]) }
                            else if (e.r === "N") { NPercent += parseFloat(eData["decimal"]) }
                            else if (e.r === "P") { PPercent += parseFloat(eData["decimal"]) }
                            else if (e.r === "W") { WPercent += parseFloat(eData["decimal"]) }
                            else if (e.r === "T") { TPercent += parseFloat(eData["decimal"]) }
                            else if (e.r === "O") { OPercent += parseFloat(eData["decimal"]) }
                        }
                    })
                })
                if (ethnicityPercentTemp > 0 && ethnicityPercentTemp < .01) { setEthnicityPercent((ethnicityPercentTemp * 100)) }
                else { setEthnicityPercent((ethnicityPercentTemp * 100).toFixed(0)) }
            }
            // 🌻🌻🌻
            else if (activeEthnicityTab === 2) { // Ancestry tab active
                ancestryData.map(aData => {
                    ancestry.map(a => {
                        if (a.selected === true && a.ancestry === aData.ancestry) {
                            ancestryPercentTemp += parseFloat(aData["decimal"])
                            if (a.r === "A") { APercent += parseFloat(aData["decimal"]) }
                            else if (a.r === "B") { BPercent += parseFloat(aData["decimal"]) }
                            else if (a.r === "L") { LPercent += parseFloat(aData["decimal"]) }
                            else if (a.r === "M") { MPercent += parseFloat(aData["decimal"]) }
                            else if (a.r === "N") { NPercent += parseFloat(aData["decimal"]) }
                            else if (a.r === "P") { PPercent += parseFloat(aData["decimal"]) }
                            else if (a.r === "W") { WPercent += parseFloat(aData["decimal"]) }
                            else if (a.r === "T") { TPercent += parseFloat(aData["decimal"]) }
                            else if (a.r === "O") { OPercent += parseFloat(aData["decimal"]) }
                        }
                    })
                })
                if (ancestryPercentTemp > 0 && ancestryPercentTemp < .01) { setAncestryPercent((ancestryPercentTemp * 100)) }
                else { setAncestryPercent((ancestryPercentTemp * 100).toFixed(0)) }
            }
            // 📐📐📐
            // Height portion of calculation
            // [0]: original (both genders), [1]: male, [2]: female
            APercent = [APercent, APercent, APercent]
            BPercent = [BPercent, BPercent, BPercent]
            LPercent = [LPercent, LPercent, LPercent]
            MPercent = [MPercent, MPercent, MPercent]
            NPercent = [NPercent, NPercent, NPercent]
            PPercent = [PPercent, PPercent, PPercent]
            WPercent = [WPercent, WPercent, WPercent]
            TPercent = [TPercent, TPercent, TPercent]
            OPercent = [OPercent, OPercent, OPercent]
            let heightPercentTemp = 0;
            let heightMinMax = [];

            // Parameter hData is each Gender|Race height percentile data object in the height local data file
            // Parameter n is the the gender options selected. 1: M, 2: F (Essentially, if both genders are selected, this function runs twice for each one)
            const heightRaceCalc = (hData, n) => {
                // This first section is for the race categories that need to rely on the general height data since the data doesn't list out these 5 specific races (Middle East, Native American, Pacific Islander, Two or more races, and Other)
                if (hData.gender_race.includes(1) && (MPercent[0] || NPercent[0] || PPercent[0] || TPercent[0] || OPercent[0])) // If the race row in the data file is 1 (all races height / average of all races) && at least one of these 5 races is selected in the race checkbox component (these 5 don't fall into the main race categories in the height file)
                {
                    let countTemp = 0; // Serves as the counter of how many percentiles fell within the height range selected.
                    for (var [percentile, heightNum] of Object.entries(hData)) { // For each row in each Gender|Race object
                        heightNum = Number(heightNum)
                        if (!isNaN(heightNum)) { // To ignore first row that's the Gender|Race header
                            heightMinMax.push(heightNum) // First we push all the height percentiles into here. Later, we take the min max.
                            if (heightNum >= height[0] && heightNum <= height[1]) { // height[0] and height[1] are the selected min max height values the user selected.
                                countTemp += .05;
                            }
                        }
                    }
                    if (countTemp === 0) { countTemp = 0.05 } // Account for if user's defined range is only below 5th percentile or above 95 percentile (a single 5th percentile).
                    MPercent[n] *= +countTemp.toFixed(2); // The + in front of the variable ensures it's a number (CHECK)
                    NPercent[n] *= +countTemp.toFixed(2);
                    PPercent[n] *= +countTemp.toFixed(2);
                    TPercent[n] *= +countTemp.toFixed(2);
                    OPercent[n] *= +countTemp.toFixed(2);
                }
                // The following sections are dedicated to the race categories that the height data has available.
                else if (hData.gender_race.includes("A") && APercent[0]) {
                    let countTemp = 0;
                    for (var [percentile, heightNum] of Object.entries(hData)) {
                        heightNum = Number(heightNum)
                        if (!isNaN(heightNum)) {
                            heightMinMax.push(heightNum)
                            if (heightNum >= height[0] && heightNum <= height[1]) {
                                countTemp += .05;
                            }
                        }
                    }
                    if (countTemp === 0) { countTemp = 0.05 }
                    APercent[n] *= +countTemp.toFixed(2);
                }
                else if (hData.gender_race.includes("B") && BPercent[0]) {
                    let countTemp = 0;
                    for (var [percentile, heightNum] of Object.entries(hData)) {
                        heightNum = Number(heightNum)
                        if (!isNaN(heightNum)) {
                            heightMinMax.push(heightNum)
                            if (heightNum >= height[0] && heightNum <= height[1]) {
                                countTemp += .05;
                            }
                        }
                    }
                    if (countTemp === 0) { countTemp = 0.05 }
                    BPercent[n] *= +countTemp.toFixed(2);
                }
                else if (hData.gender_race.includes("L") && LPercent[0]) {
                    let countTemp = 0;
                    for (var [percentile, heightNum] of Object.entries(hData)) {
                        heightNum = Number(heightNum)
                        if (!isNaN(heightNum)) {
                            heightMinMax.push(heightNum)
                            if (heightNum >= height[0] && heightNum <= height[1]) {
                                countTemp += .05;
                            }
                        }
                    }
                    if (countTemp === 0) { countTemp = 0.05 }
                    LPercent[n] *= +countTemp.toFixed(2);
                }
                else if (hData.gender_race.includes("W") && WPercent[0]) {
                    let countTemp = 0;
                    for (var [percentile, heightNum] of Object.entries(hData)) {
                        heightNum = Number(heightNum)
                        if (!isNaN(heightNum)) {
                            heightMinMax.push(heightNum)
                            if (heightNum >= height[0] && heightNum <= height[1]) {
                                countTemp += .05;
                            }
                        }
                    }
                    if (countTemp === 0) { countTemp = 0.05 }
                    (WPercent[n]) *= +countTemp.toFixed(2);

                }
            }

            // Check which measurement parameter was selected and choose corresponding height data.
            let activeHeightData = imperial ? heightDataInch : heightDataCM
            // Loop through each Gender|Race height percentile data object using the heightRaceCalc function defined above.
            activeHeightData.map(hData => {
                if (hData.gender_race.includes("M") && (activeGenderStatus === 1 || activeGenderStatus === 0)) {
                    heightRaceCalc(hData, 1)
                }
                else if (hData.gender_race.includes("F") && (activeGenderStatus === 2 || activeGenderStatus === 0)) {
                    heightRaceCalc(hData, 2)
                }
            })

            // 🤖🤖🤖
            // Final calculation that uses both raw population size and final demographic percent variables.

            // Loop through all heights within height range to find min and max at next step to dynamically adjust the shown min and max on the scrollbar.
            let allRaceHeight = [APercent, BPercent, LPercent, MPercent, NPercent, PPercent, WPercent, TPercent, OPercent]

            let originalTotalHeightPercent = 0;
            let totalMaleHeightPercent = 0;
            let totalFemaleHeightPercent = 0;

            for (const r of allRaceHeight) {
                originalTotalHeightPercent += r[0]
                totalMaleHeightPercent += r[1]
                totalFemaleHeightPercent += r[2]
            }

            // Because a slight difference in decimals that are near 1, like 1.00002 can result in a difference between the race and ethnicity numbers, rounding it to 0 is necessary if all checkboxes for a race category are selected. Console logging the total height percents below will show this
            originalTotalHeightPercent = originalTotalHeightPercent > 1 ? 1 : originalTotalHeightPercent
            totalFemaleHeightPercent = totalFemaleHeightPercent > 1 ? 1 : totalFemaleHeightPercent
            totalMaleHeightPercent = totalMaleHeightPercent > 1 ? 1 : totalMaleHeightPercent

            // console.log(originalTotalHeightPercent, totalFemaleHeightPercent, totalMaleHeightPercent)
            // console.log(((totalFemaleHeightPercent / originalTotalHeightPercent)), totalMaleHeightPercent)
            // 📐📐📐
            // Use height percents to adjust male and female population numbers
            if (heightMinMax.length > 0) {
                // Because the total male and female height percents have race percents in them, this operation will multiply both the (height and race) percents together with the dating pool numbers. Might need to adjust logic to minus total male and female height percents from the original percents to get the height portion of the percent if I want to do the race percent calculation separately.
                datingPoolCountMenTemp = (datingPoolCountMenTemp * totalMaleHeightPercent)
                datingPoolCountWomenTemp = (datingPoolCountWomenTemp * totalFemaleHeightPercent)

                setHeightRange([Math.min(...heightMinMax), Math.max(...heightMinMax)])
                if (activeGenderStatus === 0) {
                    setHeightPercent(((((totalMaleHeightPercent + totalFemaleHeightPercent) / 2) / originalTotalHeightPercent) * 100).toFixed(0))
                }
                else if (activeGenderStatus === 1) {
                    setHeightPercent(((totalMaleHeightPercent / originalTotalHeightPercent) * 100).toFixed(0))
                }
                else if (activeGenderStatus === 2) {
                    setHeightPercent(((totalFemaleHeightPercent / originalTotalHeightPercent) * 100).toFixed(0))
                }

            }
            else {
                setHeightRange(imperial ? [58, 75] : [140, 190])
                setHeightPercent(0)
            }
            // console.log(datingPoolCountWomenTemp, datingPoolCountMenTemp)
            // console.log(finalMenPop,finalWomenPop,finalBothPop)
            // console.log(datingPoolCountMenTemp,datingPoolCountMenTemp,(datingPoolCountMenTemp + datingPoolCountWomenTemp))
            // , ((datingPoolCountMenTemp, datingPoolCountWomenTemp), finalBothPop)


            // 🚻💕💍
            // Gender, sexuality, and marital status percent
            datingPoolCountTemp = parseInt(
                (datingPoolCountMenTemp * finalMenPop)
                + (datingPoolCountWomenTemp * finalWomenPop)
                + ((datingPoolCountMenTemp + datingPoolCountWomenTemp) * finalBothPop) // Trans and other
            )
            // 👥🌎🌻


            // Race, ethnicity, or ancestry percent
            // if (racePercentTemp) { datingPoolCountTemp *= racePercentTemp }
            // else if (ethnicityPercentTemp) { datingPoolCountTemp *= ethnicityPercentTemp }
            // else if (ancestryPercent) { datingPoolCountTemp *= ancestryPercent }
            // else (datingPoolCountTemp = 0)

            if (!racePercentTemp && !ethnicityPercentTemp && !ancestryPercentTemp) {
                datingPoolCountTemp = 0
            }
            setDatingPoolCount(datingPoolCountTemp)

            // 🤔🤔🤔
            // Criteria calculation section
            let estimatesPercent = 1;
            estimates.map(e => {
                estimatesPercent *= (e.value / 100)
            }
            )
            // console.log(estimatesPercent)
            setDatingPoolCount(parseInt(datingPoolCountTemp * estimatesPercent))




        }
        else {
            setDatingPoolCount(0)
            setAgePercent(0);
            setHeightPercent(0);
            setGenderPercent(0);
            setRacePercent(0);
            // setEthnicityPercent(0);
            // setAncestryPercent(0);
        }
        // }
        // else {
        //     setDatingPoolCount(0)
        // }


    }, [gender, ageRange, race, ethnicity, ancestry, sexuality, marriage, height, estimates, activeRaceTab,])


    const [displayedDatingPoolCount, setDisplayedDatingPoolCount] = useState(datingPoolCount);
    const [displayedAgePercent, setDisplayedAgePercent] = useState(agePercent);
    const [displayedHeightPercent, setDisplayedHeightPercent] = useState(heightPercent);
    const [displayedGenderPercent, setDisplayedGenderPercent] = useState(genderPercent);
    const [displayedRacePercent, setDisplayedRacePercent] = useState(racePercent);
    const [displayedEthnicityPercent, setDisplayedEthnicityPercent] = useState(ethnicityPercent);
    const [displayedAncestryPercent, setDisplayedAncestryPercent] = useState(ancestryPercent);


    // setDisplayedDatingPoolCount(datingPoolCount);
    //         setDisplayedAgePercent(agePercent);
    //         setDisplayedHeightPercent(heightPercent);
    //         setDisplayedGenderPercent(genderPercent);
    //         setDisplayedRacePercent(racePercent);
    //         setDisplayedEthnicityPercent(ethnicityPercent);
    //         setDisplayedAncestryPercent(ancestryPercent);

    // const throttleTimer = useRef(null);
    // const lastUpdateTime = useRef(0);
    // Throttling useEffect
    // useEffect(() => {
    //     const now = Date.now();

    //     // If enough time has passed, update immediately
    //     if (!lastUpdateTime.current || now - lastUpdateTime.current >= 200) {
    //         setDisplayedDatingPoolCount(datingPoolCount);
    //         setDisplayedAgePercent(agePercent);
    //         setDisplayedHeightPercent(heightPercent);
    //         setDisplayedGenderPercent(genderPercent);
    //         setDisplayedRacePercent(racePercent);
    //         setDisplayedEthnicityPercent(ethnicityPercent);
    //         setDisplayedAncestryPercent(ancestryPercent);
    //         lastUpdateTime.current = now;
    //     } else {
    //         // Schedule an update for later
    //         if (throttleTimer.current) {
    //             clearTimeout(throttleTimer.current);
    //         }

    //         throttleTimer.current = setTimeout(() => {
    //             setDisplayedDatingPoolCount(datingPoolCount);
    //             setDisplayedAgePercent(agePercent);
    //             setDisplayedHeightPercent(heightPercent);
    //             setDisplayedGenderPercent(genderPercent);
    //             setDisplayedRacePercent(racePercent);
    //             setDisplayedEthnicityPercent(ethnicityPercent);
    //             setDisplayedAncestryPercent(ancestryPercent);
    //             lastUpdateTime.current = Date.now();
    //         }, 200 - (now - lastUpdateTime.current));
    //     }

    //     return () => {
    //         if (throttleTimer.current) {
    //             clearTimeout(throttleTimer.current);
    //         }
    //     };
    // }, [datingPoolCount, agePercent, heightPercent, genderPercent, racePercent, ethnicityPercent, ancestryPercent]);


    useEffect(() => {
        if (pageValue === 2 && datingPoolCount < 1 && estimatesHintFinished && !estimatesFinishedAppearHint && !estimatesZeroAppearHint) {
            // Clear existing timer if value dropped to 0 again
            if (zeroCheckTimer.current) {
                clearTimeout(zeroCheckTimer.current);
            }

            // Wait 1 second to see if the value is still 0
            zeroCheckTimer.current = setTimeout(() => {
                // Double-check the value is still 0 before showing the message
                if (datingPoolCount < 1) {
                    setEstimatesZeroAppearHint(true);
                    setBlurOverlay(true);
                }
                zeroCheckTimer.current = null;
            }, 2500);
        } else if (datingPoolCount >= 1 && zeroCheckTimer.current) {
            // If the value goes back above 0, cancel the pending message
            clearTimeout(zeroCheckTimer.current);
            zeroCheckTimer.current = null;
        }
    }, [datingPoolCount]);



    const GradientIcon = (p) => {
        if (p.value === tabValue) {
            return (
                <>
                    <svg width={0} height={0}>
                        <linearGradient id="gradientColors" x1={1} y1={0} x2={1} y2={1} gradientTransform="rotate(25)">
                            <stop offset='0%' stopColor="#8ED4FF" />
                            {/* <stop offset='50%' stopColor="#FF0069" /> */}
                            <stop offset='100%' stopColor="#008FF5" />
                        </linearGradient>
                    </svg>
                    {p.activeIcon}
                </>)
        }
        else { return (p.inactiveIcon) }
    }







    return (
        <div className="wrapper">
            <div className="main-container">
                {/* <div style={{width: "100%", height: "50px", display: activePageBar ? "":"none"}}> */}

                {/* <Collapse
                    // in={true}
                    in={activePageBar} 
                    // collapsedSize={0}

                    sx={{
                        width: "100%",
                        // height: "50px"
                    }} 
                    > */}
                {/* <div> */}
                {/* <Box sx={{
                        width: "100%", height: "50px"
                    }}
                    > */}



                     {/* Intro */}

                {pageValue === 0 && (
                    <div className="criteriaContainer">
                        <Intro pageValue={pageValue} startChange={handlePageChange} />
                    </div>
                )}


  <div
                        className="header"
 style={{ 
 display: pageValue !== -1 ? 'none' : 'block'
    }}
                    >
                        {/* KPI stays centered */}
                        <div className="kpiContainer">
                           <h1 className='kpi'>Discovery</h1>
                        </div>

                        {/* Menu/Close Button — sits above modal */}
                        <IconButton
                            onClick={() => setMenuOpen((s) => !s)}
                            className="menuButton"
                            sx={{
                                backgroundColor: menuOpen ? "rgba(0, 0, 0, 0.04)" : "transparent",
                                boxShadow: "none",
                                transition: "background-color 0.3s ease",
                                "&:hover": {
                                    backgroundColor: menuOpen ? "rgba(0, 0, 0, 0.05)" : "transparent",
                                },
                            }}
                        >
                            {menuOpen ? <CloseIcon /> : <MenuIcon />}
                        </IconButton>


                        {/* Render modal at root-level (outside header) */}
                        <Menu
                            isOpen={menuOpen}
                            onClose={() => setMenuOpen(false)}
                            onReset={handleReset}
                            setPageValue={setPageValue}
                        />
                    </div>




                     {/* Discovery */}
{pageValue === -1 && (
                <div style={{ filter: blurOverlay ? 'blur(3px)' : 'none', transition: 'filter 1.5s' }} 
                    >
                                                 <div className="wrapperScrollDiscovery">
                                                    <div className="estimateDiagramContainerParent" >

                            <Discovery activePlanDrawer={activePlanDrawer} setActivePlanDrawer={(drawerName) => handlePageChange(-1, drawerName)}/>
                        </div>
                </div>
                </div>
           )}



                    <div className="pageNavigationContainer"
                     style={{ 
display: pageValue < 1 ? 'none' : 'block'
    }}>
                        <div className="pageNavigation">
                            <div className={tabHint === 1 ? "tabButtonBorder" : "tabButtonNoBorder"}>

                                <Chip avatar={<Avatar>1</Avatar>} variant="outlined" label="My Criteria" onClick={() => handlePageChange(1)}
                                    sx={{
                                        "& .MuiChip-avatar": {
                                            background: pageValue === 1 ? "linear-gradient(.100turn, #D0F4FF, #F2F6F8)" : "#FDFDFD"
                                            , color: pageValue === 1 ? "#4A4A4A" : "#D3D3D3"
                                        }
                                        , "&.MuiChip-root": {
                                            border: "1px solid", borderRadius: "20px", height: "auto", padding: "5px"
                                            , borderColor: pageValue === 1 ? "#9F9F9F" : "#D3D3D3"
                                            , backgroundColor: "#FFFFFF"

                                        }
                                        , "&.MuiChip-root:hover": {
                                            backgroundColor: "#FFFFFF"
                                            // backgroundColor: pageValue === 1 ? "#FFFFFF" : "#FFFFFF"
                                        }
                                        , "& .MuiChip-label": {
                                            color: pageValue === 1 ? "#4A4A4A" : "#D3D3D3"
                                            , padding: "0 6px 0 10px"
                                        }
                                    }}
                                />
                            </div>
                            <div className={tabHint === 2 ? "tabButtonBorder" : "tabButtonNoBorder"}>

                                {/* <Tooltip 
    title="First preview all 4 Criteria tabs" 
    open={showTooltip}
    onClose={() => setShowTooltip(false)}
 leaveDelay={3000} 
    arrow
>
    <span 
          onClick={() => {
                if (!tabTwoHintFinished) {
                    setShowTooltip(true);
                    // setTimeout(() => setShowTooltip(false), 5000);
                } else {
                    handlePageChange();
                }
            }}
        style={{ display: 'inline-block' }}
    > */}
                                <Chip
                                    avatar={<Avatar>2</Avatar>}
                                    variant="outlined"
                                    label="My Estimates"
                                    onClick={tabTwoHintFinished ? () => handlePageChange(2) : undefined}
                                    disabled={!tabTwoHintFinished}
                                    sx={{
                                        "& .MuiChip-avatar": {
                                            background: tabHint === 2 ? "linear-gradient(.100turn, #D0F4FF, #F3F3F3)" : pageValue === 2 ? "linear-gradient(.100turn, #D0F4FF, #F3F3F3)" : "#FDFDFD"
                                            , color: tabHint === 2 ? "#4A4A4A" : pageValue === 2 ? "#4A4A4A" : "#D3D3D3"
                                        }
                                        , "&.MuiChip-root": {
                                            border: "1px solid", borderRadius: "20px", height: "auto", padding: "5px"
                                            , borderColor: pageValue === 2 ? "#9F9F9F" : "#D3D3D3"
                                            , backgroundColor: "#FFFFFF"
                                        }, "&.MuiChip-root:hover": {
                                            backgroundColor: "#FFFFFF"
                                        }
                                        , "& .MuiChip-label": {
                                            color: tabHint === 2 ? "#4A4A4A" : pageValue === 2 ? "#4A4A4A" : "#D3D3D3"
                                            , padding: "0 6px 0 10px"
                                        }
                                    }}
                                />
                                {/* </span>
</Tooltip> */}
                            </div>
                            <div className={tabHint === 3 ? "tabButtonBorder" : "tabButtonNoBorder"}>

                                <Chip avatar={<Avatar>3</Avatar>} variant="outlined" label="My Plan" onClick={() => handlePageChange(3)}
                                    disabled={!estimatesFinishedAppearHint && !estimatesFinishedHintFinished}

                                    sx={{
                                        "& .MuiChip-avatar": {
                                            background: pageValue === 3 ? "linear-gradient(.100turn, #D0F4FF, #F3F3F3)" : "#FDFDFD"
                                            , color: pageValue === 3 ? "#4A4A4A" : "#D3D3D3"
                                        }
                                        , "&.MuiChip-root": {
                                            border: "1px solid", borderRadius: "20px", height: "auto", padding: "5px"
                                            , borderColor: pageValue === 3 ? "#9F9F9F" : "#D3D3D3"
                                            , backgroundColor: "#FFFFFF"
                                        }, "&.MuiChip-root:hover": {
                                            backgroundColor: "#FFFFFF"
                                            // backgroundColor: pageValue === 1 ? "#FFFFFF" : "#FFFFFF"
                                        }
                                        , "& .MuiChip-label": {
                                            color: pageValue === 3 ? "#4A4A4A" : "#D3D3D3"
                                            , padding: "0 6px 0 10px"
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    <div
                        className="header"
 style={{ 
 display: pageValue < 1 ? 'none' : 'block'
    }}
                    >
                        {/* KPI stays centered */}
                        <div className="kpiContainer">
                            <NumberFlow
                                className="mainKPI"
                                value={datingPoolCount}
                                suffix={"New"}
                            />
                        </div>

                        {/* Menu/Close Button — sits above modal */}
                        <IconButton
                            onClick={() => setMenuOpen((s) => !s)}
                            className="menuButton"
                            sx={{
                                backgroundColor: menuOpen ? "rgba(0, 0, 0, 0.04)" : "transparent",
                                boxShadow: "none",
                                transition: "background-color 0.3s ease",
                                "&:hover": {
                                    backgroundColor: menuOpen ? "rgba(0, 0, 0, 0.05)" : "transparent",
                                },
                            }}
                        >
                            {menuOpen ? <CloseIcon /> : <MenuIcon />}
                        </IconButton>


                        {/* Render modal at root-level (outside header) */}
                        <Menu
                            isOpen={menuOpen}
                            onClose={() => setMenuOpen(false)}
                            onReset={handleReset}
                            setPageValue={setPageValue}
                        />
                    </div>



                {/* <div className="header" style={{ display: pageValue !== 0 ? "" : "none", position: "sticky" }}>

                    <div className="kpiContainer">
                        <NumberFlow
                            className="mainKPI"
                            value={DatingPoolCount}
                            suffix={"New"}
                        />
                    </div>


        
                </div> */}


                {/* <DataPull onPull={handlePull} /> */}
                {pageValue === 1 && (
                    <Fade
                        in={pageValue === 1}
                        timeout={500}>

                        <div className="criteriaContainer">

                            <TabContext value={tabValue}>

                                <Collapse in={activeTabBar}
                                    sx={{
                                        ...(activeTabBar && {
                                            width: "100%",
                                            height: "100%",
                                        }),
                                    }}
                                    collapsedSize={0}
                                >
                                    {/* <div> */}
                                    <Box sx={{
                                        width: "100%", height: "70px", borderBottom: 1, borderColor: 'divider', display: "flex", justifyContent: "center"
                                        , background: "linear-gradient( rgb(255, 255, 255), 80%, rgb(243, 243, 243))"
                                    }}
                                    >

                                        <TabList
                                            onChange={handleTabChange} style={{
                                                overflow: "hidden"
                                            }}
                                            variant="scrollable"
                                            scrollButtons={false}
                                            // allowScrollButtonsMobile={true}
                                            visibleScrollbar={true}
                                            sx={{
                                                "& .MuiTabs-scroller": { maskImage: "linear-gradient(to right, transparent 0%, black 20px, black calc(100% - 20px), transparent calc(100% - 0px))", padding: "0 15px 0 15px" }
                                                ,
                                                "& .MuiTabs-indicator": {
                                                    backgroundColor: '#60B2FF',
                                                    height: '4px' // Adjust thickness here
                                                }
                                            }}
                                        >
                                            <Tab value="1"
                                                icon={<GradientIcon
                                                    activeIcon={<FavoriteIcon sx={{ fill: "url(#gradientColors)" }} />}
                                                    inactiveIcon={<FavoriteIcon />}
                                                    value={"1"}
                                                />}
                                                className="TabIcon"

                                                label={
                                                    <div>
                                                        <p className="tabName">Orientation</p>
                                                        {isNaN(Number(genderPercent)) ?
                                                            <p className="kpiPercent">{genderPercent}</p>
                                                            : <NumberFlow
                                                                className="criteriaKPI"
                                                                value={genderPercent}
                                                                suffix={"%"}
                                                            />}
                                                    </div>

                                                }
                                                sx={{ width: "95px", }}

                                            />
                                            <Tab value="2"
                                                onClick={() => {
                                                    setAgeHintAppearFinished(true);
                                                    setBlurOverlay(false);
                                                }}
                                                icon={<GradientIcon activeIcon={<CakeIcon
                                                    sx={{ fill: "url(#gradientColors)" }} />} inactiveIcon={<CakeIcon />} value={"2"} />}
                                                className={ageHint && !ageHintFinished && tabValue !== "2" ? "TabIcon TabIconEthnicity" : "TabIcon"}
                                                label={
                                                    <div>
                                                        <p className="tabName">Age</p>
                                                        <NumberFlow
                                                            className="criteriaKPI"
                                                            value={agePercent}
                                                            suffix={"%"}
                                                        />
                                                    </div>
                                                }
                                                sx={{
                                                    width: "70px",
                                                    visibility: "visible",
                                                    opacity: hideTabs ? 0 : 1
                                                    , transition: "visibility 0s, opacity 0.5s linear"
                                                }}
                                                disabled={disableTabs}
                                            />

                                            <Tab value="3"
                                                icon={<GradientIcon activeIcon={<HeightIcon sx={{ fill: "url(#gradientColors)" }} />} inactiveIcon={<HeightIcon />} value={"3"} />}
                                                className={heightHint && !heightHintFinished && tabValue !== "3" ? "TabIcon TabIconSubtle" : "TabIcon"}
                                                label={
                                                    <div>
                                                        <p className="tabName"> Height </p>
                                                        <NumberFlow
                                                            className="criteriaKPI"
                                                            value={heightPercent}
                                                            suffix={"%"}
                                                        />
                                                    </div>
                                                }
                                                sx={{
                                                    width: "75px",
                                                    visibility: "visible",
                                                    opacity: hideTabs ? 0 : 1
                                                    , transition: "visibility 0s, opacity 0.5s linear"
                                                }}
                                                disabled={disableTabs}
                                            />

                                            {/* <Tab value="7"
                                    icon={<GradientIcon activeIcon={<PaidIcon sx={{ fill: "url(#gradientColors)" }} />} inactiveIcon={<PaidIcon />} value={"7"} />}
                                    className="TabIcon"
                                    label={
                                        <div>
                                            <p className="tabName"> Income </p>
                                            <NumberFlow
                                                className="criteriaKPI"
                                                value={0}
                                                suffix={"%"}
                                            />
                                        </div>}
                                /> */}

                                            <Tab value="4"
                                                icon={<GradientIcon activeIcon={<FilterVintageIcon sx={{ fill: "url(#gradientColors)" }} />} inactiveIcon={<FilterVintageIcon />} value={"4"} />}
                                                className={raceHint && !raceHintFinished && tabValue !== "4" ? "TabIcon TabIconSubtle" : "TabIcon"}
                                                label={
                                                    <div>
                                                        {activeEthnicityTab === 0 ? <p className="tabName"> Race </p> : null}
                                                        {activeEthnicityTab === 1 ? <p className="tabName"> Ethnicity </p> : null}
                                                        {activeEthnicityTab === 2 ? <p className="tabName"> Ancestry </p> : null}

                                                        {activeEthnicityTab === 0 ? <NumberFlow
                                                            className="criteriaKPI"
                                                            value={racePercent}
                                                            suffix={"%"}
                                                        /> : null}
                                                        {activeEthnicityTab === 1 ? <NumberFlow
                                                            className="criteriaKPI"
                                                            value={ethnicityPercent}
                                                            suffix={"%"}
                                                        /> : null}
                                                        {activeEthnicityTab === 2 ? <NumberFlow
                                                            className="criteriaKPI"
                                                            value={ancestryPercent}
                                                            suffix={"%"}
                                                        /> : null}
                                                    </div>
                                                }
                                                sx={{
                                                    width: "80px",
                                                    visibility: "visible",
                                                    opacity: hideTabs ? 0 : 1
                                                    , transition: "visibility 0s, opacity 0.5s linear"
                                                }}
                                                disabled={disableTabs}
                                            />


                                            {/* <Tab icon={<FilterVintageIcon />} label={
                                <div style={{ whiteSpace: "pre-line" }}>
                                    <Typography style={{}} variant="caption">
                                        test
                                    </Typography>
                                    <br />
                                    <Typography variant="title">
                                    </Typography>
                                </div>
                            }
                                value="10" component="pre" style={{ minWidth: 50, whiteSpace: "pre-line" }} /> */}


                                        </TabList>
                                    </Box>
                                    {/* </div> */}
                                </Collapse>

                                <TabPanel value="1" sx={{ padding: "0" }} className="TabPanel">
                                    <div style={{ filter: blurOverlay ? 'blur(3px)' : 'none', transition: 'filter 1.5s' }} 
                                    >

                                        <Gender activeGender={gender} onGenderClick={handleGender}
                                            activeSexuality={sexuality} onSexualityClick={handleSexuality}
                                            activeMarriage={marriage} onMarriageClick={handleMarriage}
                                            activeTabBarStatus={activeTabBar}
                                        />
                                    </div>

                                </TabPanel>
                                <TabPanel value="2" sx={{ padding: "0" }}>
                                               <div style={{ filter: blurOverlay ? 'blur(3px)' : 'none', transition: 'filter 1.5s' }}>
                                    <Age activeGender={gender} ageRange={ageRange} onSlide={handleAge} agePercent={agePercent} />
                                    </div>
                                </TabPanel>
                                <TabPanel value="3" sx={{ padding: "0" }}>
                                               <div style={{ filter: blurOverlay ? 'blur(3px)' : 'none', transition: 'filter 1.5s' }}>
                                    <Height
                                        activeGender={gender} height={height} onSlide={handleHeight} activeImperial={imperial} onImperialToggle={handleImperial}
                                        activeHeightRange={heightRange} heightPercent={heightPercent}
                                    />
                                    </div>
                                </TabPanel>
                                <TabPanel value="4" sx={{ padding: 0 }}>
                                    <div
                                        className="wrapperScroll"
                                        style={{
                                            filter: blurOverlay ? 'blur(3px)' : 'none',
                                            transition: 'filter 1.5s'
                                        }}
                                    >
                                        <RaceSegmentControl
                                            activeRaceTab={activeRaceTab}
                                            raceTabs={raceTabSupport}
                                            onRaceClick={handleRaceTab}
                                        />

                                        {activeRaceTab === 0 && (
                                            <Race
                                                activeRace={race}
                                                onRaceClick={handleRace}
                                                activeRaceAll={raceAll}
                                                resetter={resetter}
                                            />
                                        )}

                                        {activeRaceTab === 1 && (
                                            <Ethnicity
                                                activeEthnicity={ethnicity}
                                                onEthnicityClick={handleEthnicity}
                                                activeEthnicityGroup={ethnicityGroup}
                                                onEthnicityGroupClick={handleEthnicityGroup}
                                                activeEthnicityAll={ethnicityAll}
                                                resetter={resetter}
                                            />
                                        )}

                                        {activeRaceTab === 2 && (
                                            <Ancestry
                                                activeAncestry={ancestry}
                                                onAncestryClick={handleAncestry}
                                                activeAncestryGroup={ancestryGroup}
                                                onAncestryGroupClick={handleAncestryGroup}
                                                activeAncestryAll={ancestryAll}
                                                resetter={resetter}
                                            />
                                        )}
                                    </div>
                                </TabPanel>

                                {/* <TabPanel value="10">
                                <Test  />
                            </TabPanel> */}

                            </TabContext>


                        </div>
                    </ Fade>
                )}

                {/* 🤔 My Estimtes */}
                <div style={{ filter: blurOverlay ? 'blur(3px)' : 'none', transition: 'filter 1.5s' }} 
                // onClick={() => setBlurOverlay(false)}
                    >
                    {pageValue === 2 && (
                        <div className="wrapperScrollEstimates">

                            <DiagramEstimates
                                outputKPI={datingPoolCount}
                                showAdditionalCriteria={showAdditionalCriteria}
                                returnToFoundationalCriteria={returnToFoundationalCriteria}
                                genderKPI={gender} sexualityKPI={sexuality} marriageKPI={marriage} ageKPI={ageRange} heightKPI={heightRange} heightMeasurement={imperial} heightRange={heightRange} raceKPI={race} ethnicityKPI={ethnicity} ancestryKPI={ancestry} activeRaceTab={activeRaceTab} raceAll={raceAll} ethnicityAll={ethnicityAll} ancestryAll={ancestryAll}
                            />
                            <Estimates activeEstimates={estimates} onInput={handleEstimates} appear={estimatesAppear} />
                        </div>
                    )}
                </div>


                {/* ⚡️ My Plan */}

                {/* <div style={{ filter: blurOverlay ? 'blur(3px)' : 'none', transition: 'filter 1.5s' }} 
                    >
                    <div
                        style={{ display: pageValue === 3 ? "" : "none" }}>
                        <div className="wrapperScrollEstimates" >
                        <div className="estimateDiagramContainerParent" >
                            <Plan activePlanDrawer={activePlanDrawer} setActivePlanDrawer={(drawerName) => handlePageChange(3, drawerName)}/>
                        </div>
                        </div>
                    </div>
                </div> */}



                <div className="criteriaContainer" style={{ display: pageValue === 3 ? "" : "none" }}>
                    <div className="cat-container">

                        <h1 className="header1">This page is still under construction. Come back later please!</h1>
                        <h1 className="header1" style={{ fontSize: "16px" }}>For questions or comments, email: nycdatingcalc@gmail.com</h1>

                        <div className="img-wrapper"
                            style={(0 === 0) ? { display: "block", animationName: "upCat" } : { display: "none" }}
                        >
                            <img src={"../images/calico.png"} className="cat-img"
                            >

                            </img>
                            <div className="blank"></div>


                        </div>
                    </div>
                </div>





                {/* Hints Section */}

                {/* 🤖 My Criteria Hints */}
                <div className="catContainerCriteria" style={pageValue === 1 && tabValue === "1" && ageHint && !ageHintFinished ? { display: "block" } : { display: "none" }}>
                    <div className="img-wrapper"
                        style={ageHintAppearFinished ? { display: "none" } : ageHintAppear ? { display: "block", animationName: "upCat" } : { display: "block", animationName: "downCat" }}
                    >
                        <Fade
                            in={ageHint}
                            {...(ageHint ? { timeout: 2000 } : {})}
                        >
                            {/* <> */}
                            <div id="calico" className="question-bubble" style={ageHintAppear ? { display: "flex" } : { display: "none" }}
                            >
                                <div className="componentHeader">
                                    <p><strong>Finished?</strong>
                                    </p>
                                    <div className="questionBubbleHeader">
                                        <button className='button-unstyled' onClick={() => { hintCloseFunction(setAgeHintAppear, setAgeHintAppearFinished); setBlurOverlay(false); }}>
                                            <CancelIcon />
                                        </button>
                                        
                                    </div>
                                </div>
                                <p>Select the blinking <span className="highlight">Age tab</span> at the top to continue!</p>
                            </div>
                        </Fade>
                        <img src={"../images/calico.png"} className="catImgCriteriaBig"></img>
                    </div>
                </div>


                <div className="catContainerCriteria" style={pageValue === 1 && tabHint === 2 && !estimatesPageAppearFinished ? { display: "block" } : { display: "none" }}>
                    <div className="img-wrapper"
                        style={estimatesPageAppearFinished ? { display: "none" } : estimatesPageAppear ? { display: "block", animationName: "upCat" } : { display: "block", animationName: "downCat" }}
                    >
                        <Fade
                            in={estimatesPageAppear}
                            {...(estimatesPageAppear ? { timeout: 2000 } : {})}
                        >
                            {/* <> */}
                            <div id="calico" className="question-bubble" style={estimatesPageAppear ? { display: "flex" } : { display: "none" }}
                            >
                                <div className="componentHeader">
                                    <p><strong>Finished?</strong></p>
                                    <div className="questionBubbleHeader" >

                                        <button className='button-unstyled' onClick={() => { hintCloseFunction(setEstimatesPageAppear, setEstimatesPageAppearFinished); setBlurOverlay(false) }}>
                                            <CancelIcon />
                                        </button>
                                    </div>

                                </div>
                                <p>
                                    Select the glowing <span className="highlight">My Estimates</span> button at the very top to continue if finished!
                                    <br></br>No rush though!
                                </p>

                            </div>
                        </Fade>
                        <img src={"../images/black.png"} className="catImgCriteriaBig"></img>
                    </div>
                </div>


                {/* 🤔 My Estimates Hints */}
                <div className="catContainerCriteria" style={pageValue === 2 && !estimatesHintFinished ? { display: "block" } : { display: "none" }}>
                    <div className="img-wrapper"
                        style={estimatesHintFinished ? { display: "none" } : estimatesHintAppear ? { display: "block", animationName: "upCat" } : { display: "block", animationName: "downCat" }}
                    >
                        <Fade
                            in={estimatesHintAppear}
                            {...(estimatesHintAppear ? { timeout: 2000 } : {})}
                        >
                            <div id="calico" className="question-bubble" style={estimatesHintAppear ? { display: "flex" } : { display: "none" }}>
                                {/* <div className="componentHeader">
                                    <p><strong>{currentEstimatesDialogueSteps[currentEstimatesDialogueStep].header}</strong></p>
                                    <div className="questionBubbleHeader" onClick={() => {
                                        hintCloseFunction(setEstimatesHintAppear, setEstimatesHintFinished)
                                        setEstimatesAppear(true)
                                        setShowAdditionalCriteria(true)
                                        setReturnToFoundationalCriteria(true)
                                    }}>
                                        <CancelIcon />
                                    </div>
                                </div> */}

                                <div className="dialogue-content">
                                    {currentEstimatesDialogueSteps[currentEstimatesDialogueStep].content}
                                </div>

                                <div className="dialogue-navigation" style={{ marginTop: '0px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div className="step-indicator" style={{ fontSize: '12px', color: '#47a1c1ff' }}>
                                        {currentEstimatesDialogueStep + 1} of {currentEstimatesDialogueSteps.length}
                                    </div>

                                    <button
                                        onClick={nextDialogueStep}
                                        style={{
                                            padding: '8px 14px',
                                            backgroundColor: '#00aaffff',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '20px',
                                            cursor: 'pointer',
                                            fontSize: '14px'
                                        }}
                                    >
                                        {currentEstimatesDialogueSteps[currentEstimatesDialogueStep].isLast ? 'Got it!' : 'Next'}
                                    </button>
                                </div>
                            </div>
                        </Fade>
                        <img src={"../images/white.png"} className="catImgCriteria"></img>
                    </div>
                </div>



                {/* Hint for if dating pool count reaches 0 */}
                <div className="catContainerCriteria" style={pageValue !== 0 && estimatesZeroAppearHint ? { display: "block" } : { display: "none" }}>
                    <div
                        className={`img-wrapper ${!estimatesZeroAppearHint && !estimatesZeroHintFinished ? 'cat-hidden' :
                            estimatesZeroAppearHint && !estimatesZeroHintFinished ? 'cat-up' :
                                'cat-down'
                            }`}
                    >
                        <Fade
                            in={estimatesZeroAppearHint}
                            {...(estimatesZeroAppearHint ? { timeout: 2000 } : {})}
                        >
                            <div id="calico" className="question-bubble" style={!estimatesZeroHintFinished ? { display: "flex" } : { display: "none" }}>
                                <div className="componentHeader">
                                    <p><strong>Oh no!</strong></p>
                                    <div className="questionBubbleHeader" onClick={() => { setEstimatesZeroHintFinished(true); setBlurOverlay(false) }}>
                                        <CancelIcon />
                                    </div>
                                </div>
                                <p>Your dating pool’s at 0, but <span className="highlight">finish up </span> your remaining estimates to move forward.</p>
                            </div>
                        </Fade>
                        <img src={"../images/white.png"} className="catImgCriteria"></img>
                    </div>
                </div>

                {/* Hint for when finished Estimates Tab */}
                <div className="catContainerCriteria" style={pageValue !== 0 && estimatesFinishedAppearHint ? { display: "block" } : { display: "none" }}>
                    <div
                        className={`img-wrapper ${!estimatesFinishedAppearHint && !estimatesFinishedHintFinished ? 'cat-hidden' :
                            estimatesFinishedAppearHint && !estimatesFinishedHintFinished ? 'cat-up' :
                                'cat-down'
                            }`}
                    >
                        <Fade
                            in={estimatesFinishedAppearHint}
                            {...(estimatesFinishedAppearHint ? { timeout: 2000 } : {})}
                        >
                            <div id="calico" className="question-bubble" style={!estimatesFinishedHintFinished ? { display: "flex" } : { display: "none" }}>
                                <div className="componentHeader">
                                    <p><strong>Nice work!</strong></p>
                                    <div className="questionBubbleHeader" onClick={() => { setEstimatesFinishedHintFinished(true); setBlurOverlay(false) }}>
                                        <CancelIcon />
                                    </div>
                                </div>
                                <p>All that estimating can be tiring, but this reflection really matters!</p>
                                <p>Now click the <span className="highlight">My Plan</span> button at the top.</p>
                            </div>
                        </Fade>
                        <img src={"../images/white.png"} className="catImgCriteriaBig"></img>
                    </div>
                </div>





            </div>

            <div className="statusBarTop"></div>
            <div className="statusBarBottom"></div>

            <div className="background">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>

        </div>
    )
};


//Note1: The reason we need this ethnicityTemp value is because, before, I was calling setEthnicity directly and then trying to access that updated ethnicity field in the function below that checks to see if every ethnicity in a particuar ethnicityGroup was selected. Since states are update immediately, the second function wasn't working because it was still receiving the old ethnicity state before the update. By using this ethnicityTemp value, we can immediately use it in the second function since the assignment is sychronously defined first before the function uses it.